import { 
    tonKhoAVP, HomePage, 
    salesQuotation, CompanySales,
    StockDashboard, CompanySaleOders, 
    CompanySaleOderDetails, 
    CompareCompanySales, ServicesStatus ,
    AOP, tonKhoGiuHang, 
    Permission, User} from "../page";
// path: string;
// name: string;
// component: any;
// props?: any;
// layout?: any
const routers = [
    {
        path: '/TonKhoGiuHang',
        name: 'Báo cáo tồn kho giữ hàng',
        component: tonKhoGiuHang
    },
    {
        path: '/TonKhoAVP',
        name: 'Báo cáo tồn kho',
        component: tonKhoAVP
    },
    {
        path: '/',
        name: 'Home Page',
        component: HomePage
    },
    {
        path: '/SalesQuotation',
        name: 'Lập đơn hàng',
        component: salesQuotation
    },
    {
        path: '/CompanySales',
        name: 'Doanh số công ty',
        component: CompanySales
    },
    {
        path: '/StockDashboard',
        name: 'Tồn kho - biểu đồ',
        component: StockDashboard
    },
    {
        path: '/CompanySaleOders',
        name: 'Đơn hàng chờ xuất kho',
        component: CompanySaleOders
    },
    {
        path: '/CompanySaleOderDetails',
        name: 'Doanh số - Đơn hàng',
        component: CompanySaleOderDetails
    },
    {
        path: '/CompareCompanySales',
        name: 'So sánh doanh số cùng kỳ',
        component: CompareCompanySales
    },
    {
        path: '/servicesStatus',
        name: 'Tình trạng dịch vụ IT',
        component: ServicesStatus
    },
    {
        path: '/AOP',
        name: 'Thống kê doanh số từng sales',
        component: AOP
    },
    {
        path: '/Permission',
        name: 'Phân quyền',
        component: Permission
    },
    {
        path: '/User',
        name: 'User',
        component: User
    },
]

export default routers
